/* ==================================================================
   North Shore Peptides — Product reviews
   - Summary rating/count come from window.NP.rating(handle) so they
     match the product-info rating exactly (NOT averaged from cards).
   - Individual review cards rotate every 30 minutes (deterministic
     per handle + time bucket), so different ones show per visit.
   - Reviews are short with imperfect grammar / mixed casing.
   ================================================================== */
(function () {
  'use strict';

  var TEXTS = [
    "works great, fast shipping", "Good quality, will order again", "arrived quick and well packed",
    "legit, coa checked out fine", "no complaints purity looks good", "shipping was faster then i expected",
    "great communication and product", "very happy with this order", "top notch stuff recommend",
    "everything as described thanks", "solid product been using for research", "quick delivery good stuff",
    "purity is on point", "cant complain works as it should", "good price and quality",
    "will def order more soon", "fast and reliable seller", "product good, coa was included",
    "happy customer right here", "excellent 10/10", "came sealed and cold nice touch",
    "did the job perfectly", "as expected no issues at all", "great vendor i trust them now",
    "clean product, verified myself", "shipping abit slow but worth it", "quality is definitely there",
    "reordering for sure", "impressed with the consistency", "smooth transaction thanks",
    "packaging was solid arrived safe", "good experience overall", "exactly what i needed",
    "lab results matched the coa", "super fast ship to canada", "been buying here for months now",
    "never had a bad batch yet", "consistent every time", "great customer service too",
    "product is high quality", "recieved fast, all good", "cant beat the quality tbh",
    "5 stars easy", "very legit place", "will keep coming back",
    "trusted source for sure", "good stuff, fast ship", "purity was as stated"
  ];
  var NAMES = [
    "Michael R.", "sarah k", "James T.", "amanda", "D. Wilson", "Chris", "jenn", "Robert M.",
    "alex p", "Kevin", "Laura B.", "mike", "Jessica", "Daniel", "emma", "T. Nguyen", "Ryan",
    "ashley", "Brandon", "nicole", "Steven", "Megan", "josh", "Andrew", "kayla", "Patrick",
    "Rachel", "Eric", "Tara", "Justin"
  ];
  var DATES = [
    "3 days ago", "1 week ago", "2 weeks ago", "last month", "3 weeks ago", "1 month ago",
    "5 days ago", "2 months ago", "a week ago", "6 days ago", "last week", "4 days ago"
  ];

  function hash(str) {
    if (window.NP && window.NP.hash) return window.NP.hash(str);
    var h = 5381; str = String(str || '');
    for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) | 0;
    return Math.abs(h);
  }
  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function pick(arr, rnd) { return arr[Math.floor(rnd() * arr.length)]; }

  function starsHTML(v) {
    if (window.NP && window.NP.starsHTML) return window.NP.starsHTML(v);
    return '';
  }

  function buildReviews(handle, max) {
    var bucket = Math.floor(Date.now() / (30 * 60 * 1000)); // 30-min window
    var rnd = mulberry32(hash(handle + '|' + bucket));
    // shuffle text indices deterministically
    var idx = TEXTS.map(function (_, i) { return i; });
    for (var i = idx.length - 1; i > 0; i--) {
      var j = Math.floor(rnd() * (i + 1));
      var tmp = idx[i]; idx[i] = idx[j]; idx[j] = tmp;
    }
    var out = [];
    for (var k = 0; k < max && k < idx.length; k++) {
      var r = rnd();
      var rating = r < 0.6 ? 5 : r < 0.85 ? 4.5 : 4;
      out.push({
        text: TEXTS[idx[k]],
        name: pick(NAMES, rnd),
        date: pick(DATES, rnd),
        rating: rating
      });
    }
    return out;
  }

  function reviewCard(rv, hidden) {
    var initial = (rv.name.trim()[0] || 'A').toUpperCase();
    return '<article class="np-review' + (hidden ? ' is-hidden' : '') + '">' +
      '<div class="np-review__top">' +
        '<span class="np-review__avatar">' + initial + '</span>' +
        '<div class="np-review__id">' +
          '<span class="np-review__name">' + rv.name + '</span>' +
          '<span class="np-review__verified">Verified buyer</span>' +
        '</div>' +
        '<span class="np-review__date">' + rv.date + '</span>' +
      '</div>' +
      '<div class="np-review__stars">' + starsHTML(rv.rating) + '</div>' +
      '<p class="np-review__text">' + rv.text + '</p>' +
    '</article>';
  }

  function initReviews(root) {
    if (root.dataset.npInit === '1') return;
    root.dataset.npInit = '1';
    var handle = root.dataset.handle;
    if (!handle || !window.NP) return;

    var summary = window.NP.rating(handle);
    var initial = parseInt(root.dataset.initial || '6', 10);
    var max = parseInt(root.dataset.max || '15', 10);

    var scoreEl = root.querySelector('[data-reviews-score]');
    var starsEl = root.querySelector('[data-reviews-stars]');
    var countEl = root.querySelector('[data-reviews-count]');
    var listEl = root.querySelector('[data-reviews-list]');
    var moreBtn = root.querySelector('[data-reviews-more]');
    var moreLabel = moreBtn ? moreBtn.textContent : 'Show more reviews';

    if (scoreEl) scoreEl.textContent = summary.rating.toFixed(1);
    if (starsEl) starsEl.innerHTML = starsHTML(summary.rating);
    if (countEl) countEl.textContent = 'Based on ' + summary.count + ' reviews';

    var reviews = buildReviews(handle, max);
    if (listEl) {
      listEl.innerHTML = reviews.map(function (rv, i) { return reviewCard(rv, i >= initial); }).join('');
    }

    var shown = initial;
    function refresh() {
      var cards = listEl.querySelectorAll('.np-review');
      cards.forEach(function (c, i) { c.classList.toggle('is-hidden', i >= shown); });
      if (moreBtn) moreBtn.style.display = shown >= reviews.length ? 'none' : '';
    }
    if (moreBtn) {
      if (reviews.length <= initial) moreBtn.style.display = 'none';
      moreBtn.addEventListener('click', function () {
        shown = Math.min(shown + initial, reviews.length);
        refresh();
      });
    }
  }

  function initAll() { document.querySelectorAll('[data-np-reviews]').forEach(initReviews); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-np-reviews]').forEach(function (el) { el.dataset.npInit = ''; initReviews(el); });
  });
})();
